import {InsurerList} from "./InsurerList";
import {InsurerEdit} from "./InsurerEdit";
import {InsurerCreate} from "./InsurerCreate";

export default {
    list: InsurerList,
    create: InsurerCreate,
    edit: InsurerEdit
};
